import { SyllabusService } from 'src/app/_services/syllabus.service';


import { Component, Input, OnInit } from '@angular/core';
import { ResultData } from 'src/app/_models/ResultData';
import { AuthService } from './../../_services/auth.service';
import { QuizService } from './../../_services/quiz.service';
import { StudentService } from './../../_services/student.service';

@Component({
  selector: 'app-change-quiz-area',
  templateUrl: './change-quiz-area.component.html',
  styleUrls: ['./change-quiz-area.component.css']
})
export class ChangeQuizAreaComponent implements OnInit {
  learner:any = undefined
  loading =false;
  server_student_user_id=0
  syllabusinfo:any=undefined
  quizarea_syllabus = { topics: [], selectedTopics: [] }
  subscription:any=undefined
  @Input() newQuizRequest=false
  private category = "topic"

  constructor(
    public authService: AuthService,
    private studentService: StudentService,
    private syllabusService:SyllabusService,
    private quizService: QuizService
  ) { }

  ngOnInit(): void {

    this.studentService.minStudentData.subscribe(
      data => {
        this.learner = data
        this.server_student_user_id=this.learner.server_user_id
        this.subscription = this.learner['subscription_object']
        this.loadSyllabus()
        }
    )

  }

  updateQuizAreaItem(subTopicId: number) {

    if (this.subscription.server_subscription_id != 0) {
      this.quizService.updateQuizAreaItem(this.subscription.server_subscription_id, subTopicId, this.category).subscribe(
        value => {
          if (value.topicSubTopicId != 0) {
            this.loadSyllabus()
          }
        }
      )

    }
  }

  loadSyllabus(){
    this.loading=true
    this.syllabusService.getSyllabusInfo(this.server_student_user_id).subscribe({
      next:(data:ResultData)=>{
        this.loading=false
        this.syllabusinfo=data.rs.data['syllabus']
      }
    }

    )
  }
}
